import { render, staticRenderFns } from "./roundMinus.vue?vue&type=template&id=149627f1&scoped=true&"
import script from "./roundMinus.vue?vue&type=script&lang=js&"
export * from "./roundMinus.vue?vue&type=script&lang=js&"
import style0 from "./roundMinus.vue?vue&type=style&index=0&id=149627f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149627f1",
  null
  
)

export default component.exports